import React, { useEffect, useState } from 'react'
import 'bootstrap/dist/css/bootstrap.min.css';
import { PiArrowLeftBold } from "react-icons/pi";
import { Link, useParams } from 'react-router-dom';
import Card from 'react-bootstrap/Card';
import axios from 'axios';
import { dataDecrypt, dataEncrypt } from '../app/utils/encryption-helper';
import Collapsible from 'react-collapsible';
import { useSelector } from 'react-redux';
import LoginOtp from './login-screen';
import LOGO from './../assets/images/vyapar_live_main_logo.png';
import { ApisService } from '../app/core/apis.service';
import { AppConfig } from '../app/config';
import { formatDateTimeInIST } from '../components/indiaDateFormate';
import { TransactionDetailsUI } from '../components/transaction-details-ui';




export const Invoice = () => {
  const [invoiceData, setinvoiceData] = useState<any>([]);
  const [isOtpEntered, setIsOtpEntered] = useState(false);
  const [otpReference, setOtpReference] = useState('');
  const userData = useSelector((state: any) => state)

  const routerParams = useParams();
  //time 
  function formatTimestamp(timestamp: number): string {
    const dateObj = new Date(timestamp);
    const year = dateObj.getFullYear();
    const month = String(dateObj.getMonth() + 1).padStart(2, '0');
    const day = String(dateObj.getDate()).padStart(2, '0');
    const hours = dateObj.getHours();
    const minutes = String(dateObj.getMinutes()).padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';
    const formattedHours = hours % 12 === 0 ? 12 : hours % 12;
    return `${year}-${month}-${day} ${formattedHours}:${minutes} ${ampm}`;
  }
  const created_date: string = formatTimestamp(invoiceData[0]?.created_date);
  console.log(created_date);


  useEffect(() => {
    loadInvoice();
  }, []);

  useEffect(() => {
    if (userData?.UserDataReducer?.otp) {
      setIsOtpEntered(true);
    }
  }, [userData])

  async function loadInvoice(): Promise<void> {
    try {
      const res = await ApisService.getTransactionData('getById_v2', routerParams.id || '');
      const data: any = res.data.data;
      const transactionData = JSON.parse(dataDecrypt(data));
      setinvoiceData([...transactionData]);
      const invoiceId = JSON.parse(dataDecrypt(routerParams.id as string));
      if (transactionData[0]) {
        const preparedReference = dataEncrypt(JSON.stringify({ invoice: invoiceId?.id, id: transactionData[0].id, type: 'invoice' }));
        setOtpReference(preparedReference);
      }

    } catch (error) {
      console.error('Error in transaction:', error);
    }
  }
  const Invoicedata = () => {
    const invoiceDetails = invoiceData[0]?.invoice_details;
    const invoiceElements = [];
    for (let i = 0; i < invoiceDetails?.length; i++) {
      const invoicedata = invoiceDetails[i];
      const invoice = invoicedata.bill_no;
      const invoicedate = formatTimestamp(invoicedata?.invoice_date);
      const invoicestatus = invoicedata.status;
      if (invoicedata.ref_invoice_to) {
        const invoiceElement = (
          <div key={i} className='mt-2'>
            <Collapsible trigger={<Card className='box-shadow mb-3'>
              <Card.Body style={{ lineHeight: '0.1' }}>
                <p style={{ color: "#274472" }}>Invoice #{invoice}</p>
                <p>{formatDateTimeInIST(invoicedata?.invoice_date)}</p>
                <p>Status:<span style={{ color: "#FF0000" }}>{invoicestatus}</span></p>
              </Card.Body>
            </Card>}>

              <Card className='box-shadow mb-3'>
                <Card.Body style={{ lineHeight: '0.1' }} ><p style={{ color: "#274472" }}>Invoice #{invoicedata.ref_invoice_to.bill_no}</p>
                  <div className='d-flex justify-content-between'>
                    <p >{formatTimestamp(invoicedata.ref_invoice_to.invoice_date)}</p>
                    <p style={{ color: "#274472" }}>{invoicedata.ref_invoice_to.status}</p>
                  </div>
                </Card.Body>
              </Card>
            </Collapsible>

          </div>

        );
        invoiceElements.push(invoiceElement);
      }
      else {
        const invoiceElement = (
          <div key={i} className='mt-2'>
            <Card className='box-shadow rounded-4 mb-3'>
              <Card.Body>
                <div className='d-flex justify-content-between align-items fs-14'>
                  <div >
                    <p className='m-0'>{formatDateTimeInIST(invoiceData[0]?.created_date)}</p>
                    <p className='m-0'><b>Total Amount :</b> ₹ {invoiceData[0]?.invoice_details[0]?.invoice_amount}</p>
                    <p className='fs-15 mb-0 pb-0'><b>Status : <span style={{ color: "#274472", textTransform: 'capitalize' }}>{invoicestatus}</span></b></p>
                  </div>
                  <a target='_blank' href={`${AppConfig.BASE_URL}/pdfs/${invoiceData[0]?.id}/invoice-pdf/${invoice}`}>
                      Invoice #{invoice}
                  </a>
                </div>
              </Card.Body>
            </Card>
          </div>
        );
        invoiceElements.push(invoiceElement);
      }
    }
    return (invoiceDetails?.length > 0 ? <div>{invoiceElements}</div>:<div className='text-center primary-color my-2'>Invoice not generated</div>);

  }
  return (
    <div>
      {!isOtpEntered && <LoginOtp reference={otpReference} transactionId={invoiceData[0]?.id} />}
      {isOtpEntered && <>
        <div className='d-flex justify-content-between p-3 align-items-center' style={{ backgroundColor: "#274472", color: "white" }}>
          <Link to={`/order/${routerParams.id}`}><span ><PiArrowLeftBold size={22} className='text-white' /></span></Link>
          <span style={{ lineHeight: "0", textAlign: "center" }}><h4>Invoice List</h4><div>{('currency_symbol' in (invoiceData[0]?.buyer || {})) ? (
                  <>{invoiceData[0]?.buyer?.name}</>
                ) : ('currency_symbol' in (invoiceData[0]?.seller || {})) ? (
                  <>{invoiceData[0]?.seller?.name}</>
                ) : (
                  <p></p>
                )}</div></span>
          <img src={LOGO} alt="" height={60} />
        </div>
        <br />
        <div className='container-fluid'>
          <div style={{ backgroundColor: "white", borderRadius: "3px" }} className='mb-4'>
            {/* <Card className='box-shadow rounded-4 '>
              <Card.Body className='p-2'>
                <div className='row text-center'>
                  <div className='col-md-4 my-2 light-grey-right-border'>
                     <h6 className='mb-0'>Seller</h6>
                     <span>{invoiceData[0]?.seller?.name}</span>
                  </div>
                  <div className='col-md-4 my-2 light-grey-right-border'>
                     <h6 className='mb-0'>Txn Date</h6>
                     <span>{formatDateTimeInIST(invoiceData[0]?.created_date)}</span>
                  </div>
                  <div className='col-md-4 my-2'>
                     <h6 className='mb-0'>Txn Id</h6>
                     <span>{invoiceData[0]?._id}</span>
                  </div>
                </div>
              </Card.Body>
            </Card> */}
            <TransactionDetailsUI data={[{header: 'Seller',value: invoiceData[0]?.seller?.name},{header: 'Txn Date',value: formatDateTimeInIST(invoiceData[0]?.created_date)},{header: 'Txn Id',value: invoiceData[0]?._id}]} />
          </div>

          {Invoicedata()}
          <div className='text-center'>
            <Link to={`/order/${routerParams.id}`}><button className='px-4 py-2 rounded my-2 fs-14'>Track All Steps of This Transaction</button></Link>
          </div>
        </div>
      </>}
    </div>

  )
}
